<template>
  <ProgressCircular v-if="loading" />
  <div v-else>
    <form novalidate ref="updateEventForm" @submit.prevent="() => {}">
      <FormHeader
        :loading="loading"
        :disabled="disabled"
        :link="'page-events'"
        :title="
          data.title
            ? `${data.title} событие: ${category.title}`
            : `Создать событие: ${category.title}`
        "
      />
      <v-row no-gutters>
        <v-col cols="8">
          <HeaderSteppers
            :tabs="$options.tabsNav"
            :rules="validationErrors"
            :isNew="isNew"
          >
            <template #0>
              <FormEventMain
                :loading="loading"
                :disabled="disabled"
                :data="fields"
                :category="category"
                :validation-errors="validationErrors"
                :isNew="isNew"
                :event-attributes="fields.attributes"
                @change:title="fields.title = $event"
                @change:slug="fields.slug = $event"
                @input:slug="$v.fields.slug.$touch"
                @change:bookingType="fields.bookingType = $event"
                @change:subtitle="fields.subtitle = $event"
                @change:thumbnailId="fields.thumbnailId = $event"
                @change:images="fields.images = $event"
                @change:price="fields.price = Number($event)"
                @change:description="fields.description = $event"
                @onChangeContent="$emit('change:descriptionForMobile', $event)"
                @change:ageRestriction="fields.ageRestriction = Number($event)"
                @set-location="setLocation"
                @update-location="updateLocation"
                @update-attribute-value="updateAttributeValue"
              />
            </template>
            <template #1>
              <div v-if="isEventSchedulesLoading" class="wrapper">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
              <div v-else>
                <template v-if="!getEventSchedulesArrayLength">
                  <ErrorMessage :message="'Хотя бы одно расписание обязательно'" />
                </template>
                <template v-else>
                  <PageContent height="65">
                    <v-row
                      v-for="(eventSchedule, eventScheduleIndex) in eventSchedules"
                      :key="eventSchedule.id"
                    >
                      <v-col cols="12">
                        <CardEventSchedules
                          :item="eventSchedule"
                          :item-index="eventScheduleIndex"
                          :isFormLoading="loading"
                          :isMutationLoading="disabled"
                          :is-only-edit="isPrimaryCategoryMovie"
                          @edit="editSchedule(eventSchedule, eventScheduleIndex)"
                          @delete-event-shedule="eventScheduleDeleteHandler"
                        />
                      </v-col>
                    </v-row>
                  </PageContent>
                </template>
                <v-container>
                  <v-row class="flex flex-row justify-lg-space-between">
                    <v-btn
                      v-if="!isPrimaryCategoryMovie"
                      :loading="loading"
                      :disabled="disabled"
                      @click="addScheduleClick"
                    >
                      Добавить расписание
                    </v-btn>
                    <v-btn :loading="loading" :disabled="disabled" @click="$emit('generate-event-schedule')">Сгенерировать расписание</v-btn>
                  </v-row>
                </v-container>
              </div>
            </template>
            <template #2>
              <div v-if="isEventSeatingLoading" class="wrapper">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
              <PageContent v-else>
                <FormEventPlaces
                  :data="seating"
                  :loading="loading"
                  :event-id="data.id"
                  :is-only-edit="isPrimaryCategoryMovie"
                  @delete-seat-row="$emit('delete-seat-row', $event)"
                  @delete-seat-zone="$emit('delete-seat-zone', $event)"
                  @delete-seat="$emit('delete-seat', $event)"
                  @seating="$emit('seating', $event)"
                />
              </PageContent>
            </template>
            <template #3>
              <div
                v-if="isEventTicketGroupsLoading || isEventSeatingLoading"
                class="wrapper"
              >
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
              <PageContent v-else>
                <FormEventTickets
                  :data="ticketGroups"
                  :loading="isEventTicketGroupsLoading"
                  :event-schedules="eventSchedules"
                  :event-seat-zones="getZones"
                  :is-only-edit="isPrimaryCategoryMovie"
                  @ticket-update="updateTicketHandler"
                  @remove="$emit('delete-ticket-group', $event)"
                />
              </PageContent>
            </template>
          </HeaderSteppers>
        </v-col>
        <v-col cols="4">
          <ManageSidePanel
            isShowSortOrder
            :is-new="!data.id"
            :created-at="data.createdAt"
            :updated-at="data.updatedAt"
            :published-at="data.publishedAt"
            :author="data.author"
            :is-loading="loading"
            :is-submit-disabled="disabled || isPrimaryCategoryMovie"
            :language="language"
            :entity-id="data.id"
            :entity-type="'event'"
            :translations="fields.translations"
            :sortOrder="fields.sortOrder"
            :tooltip-msg="
              isPrimaryCategoryMovie
                ? 'Запрещено редактирование событий с категорией Кино'
                : ''
            "
            @delete="$emit('delete-event')"
            @cancel="$router.push({ name: 'page-events' })"
            @submit="submit"
            @update-translations="Object.assign(fields.translations, $event)"
            @language-update="$emit('language-update', $event)"
            @update-sort-order="fields.sortOrder = Number($event)"
          >
            <template #info-append>
              <v-row align="center">
                <v-col cols="6"> Резерваций:</v-col>
                <v-col cols="6">
                  <router-link
                    :to="{
                      name: 'page-orders-event',
                      query: { id: data.id }
                    }"
                  >
                    {{ reservationsCount }}
                  </router-link>
                </v-col>
              </v-row>
              <StatusPicker
                align="center"
                cols="12"
                title="Статус:"
                :disabled="disabled"
                :loading="loading"
                :status="fields.status"
                @status:change="fields.status = $event"
              />
              <v-row v-if="!isNew" align="center">
                <v-col cols="6">
                  <span>Посмотреть на сайте</span>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    icon
                    link
                    color="primary"
                    target="_blank"
                    :href="redirerectToWebPortal"
                    :disabled="disabled"
                    :loading="loading"
                  >
                    <v-icon>mdi-web</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="6" class="pt-6"> Архивировано:</v-col>
                <v-col cols="6">
                  <v-switch
                    inset
                    dense
                    hide-details
                    :disabled="disabled"
                    :loading="loading"
                    v-model="fields.isArchived"
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="6" class="pt-6"> Не отображать на тур. портале:</v-col>
                <v-col cols="6">
                  <v-switch
                    inset
                    dense
                    hide-details
                    :disabled="disabled"
                    :loading="loading"
                    v-model="fields.notListedOnPortal"
                  />
                </v-col>
              </v-row>
            </template>
            <template #body>
              <v-card flat>
                <v-card-subtitle class="grey--text"> Связи</v-card-subtitle>
                <v-card-text>
                  <v-row no-gutters v-if="category">
                    <v-col cols="12">
                      <span>Категория</span>
                      <v-select
                        chips
                        disabled
                        outlined
                        dense
                        item-value="id"
                        item-text="title"
                        return-object
                        clearable
                        :value="category"
                        :items="categories"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <span>Альтернативные категории</span>
                      <v-select
                        chips
                        multiple
                        outlined
                        dense
                        item-value="id"
                        item-text="title"
                        :items="
                          categories.filter(
                            categoryItem => categoryItem.id !== primaryCategory
                          )
                        "
                        :disabled="disabled"
                        :loading="loading"
                        return-object
                        v-model="fields.altCategories"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col v-if="!!cities" cols="12">
                      <span>Город*</span>
                      <v-select
                        id="city"
                        chips
                        outlined
                        dense
                        item-value="id"
                        item-text="title"
                        clearable
                        :disabled="disabled"
                        :loading="loading"
                        :items="cities"
                        :error-messages="validationErrors.cityId"
                        v-model="fields.cityId"
                      >
                        <template #selection="{ item }">
                          <v-chip>
                            {{ item.title }}
                            <v-btn
                              icon
                              x-small
                              @click.stop="
                                fields.cityId = null
                                fields.placeId = null
                              "
                            >
                              <v-icon> mdi-close</v-icon>
                            </v-btn>
                          </v-chip>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col v-if="!!places" cols="12">
                      <span>Место</span>
                      <PlacePicker
                        dense
                        :loading="loading"
                        :value="fields.placeId"
                        @change="fields.placeId = $event"
                      />
                    </v-col>
                    <Organizer
                      :profileType="fields.profileType"
                      :profileId="fields.profileId"
                      :profileTypeError="validationErrors.profileType"
                      :loading="loading"
                      :disabled="disabled"
                      @input:profile-type="fields.profileType = $event"
                      @input:profile-id="fields.profileId = $event"
                    />
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </ManageSidePanel>
        </v-col>
      </v-row>
      <FormDialogEvent
        ref="FormDialogEvent"
        :eventId="data.id"
        :data="eventSchedule"
        :idx="eventScheduleIdx"
        :timezone="getTimeZone"
        :is-only-edit="isPrimaryCategoryMovie"
        @change-event-schedules="ChangeEventScheduleHandler"
        @delete-event-shedule="eventScheduleDeleteHandler"
      />
    </form>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import prepareTranslations from '@/mixins/translations/prepareTranslations.mix'

import moment from 'moment'
import { defaultDateFormat, apiFormat } from '@/configs/date.js'
import ticketNav from '@/configs/ticketNav'
import { sortListProfileTypes as profilesTypes } from '@/configs/profileTypes'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import { fieldGenerator, formAttributeObject } from '@/utils/attributes.js'
import validationRules from '@/pages/event/form/validationRules.js'
import Geolocation from '@/utils/types/Geolocation.js'

import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel'
import FormHeader from '@/components/form-header'
import HeaderSteppers from '@/components/header-steppers'
import FormEventMain from '@/components/event/main'
import CardEventSchedules from '@/components/event/schedules/card'
import FormDialogEvent from '../dialog/'
import FormEventPlaces from '@/components/event/places/form'
import FormEventTickets from '@/components/event/tickets'
import ErrorMessage from '@/components/error-messages/'
import StatusPicker from '@/components/status-picker'
import PlacePicker from '@/components/place-picker'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'
import Organizer from '@/components/organizer'

export default {
  name: 'FormEvent',
  components: {
    PageContent,
    FormHeader,
    HeaderSteppers,
    ManageSidePanel,
    FormEventMain,
    CardEventSchedules,
    FormDialogEvent,
    FormEventPlaces,
    FormEventTickets,
    ErrorMessage,
    StatusPicker,
    PlacePicker,
    ProgressCircular,
    Organizer
  },
  mediaTypesByKeys: mediaTypesByKeys(),
  validationRules,
  profilesTypes,
  tabsNav: ticketNav,
  defaultDateFormat,
  extends: FormAbstract,
  mixins: [validationTranslations, prepareTranslations],
  props: {
    data: {
      type: Object,
      default: null
    },
    category: {
      type: Object,
      required: true,
      default: () => ({})
    },
    categories: {
      type: Array,
      default: () => []
    },
    places: {
      type: Array,
      default: null
    },
    cities: {
      type: Array,
      default: null
    },
    routes: {
      type: Array,
      default: null
    },
    eventSchedules: {
      type: Array,
      default: null
    },
    seating: {
      type: [Array, Object],
      default: null
    },
    isEventSchedulesLoading: {
      type: Boolean,
      default: false
    },
    isEventSeatingLoading: {
      type: Boolean,
      default: false
    },
    ticketGroups: {
      type: Object,
      default: null
    },
    isEventTicketGroupsLoading: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: null
    },
    isNew: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    reservationsCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      primaryCategory: this.category.id,
      fields: {
        title: null,
        description: null,
        descriptionForMobile: null,
        slug: undefined,
        bookingType: null,
        status: null,
        isArchived: false,
        altCategories: [],
        images: [],
        videos: [],
        address: new Geolocation(),
        ageRestriction: null,
        cityId: null,
        placeId: null,
        price: null,
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoDisallowIndex: false,
        seoMetaKeywords: null,
        seoRelCanonical: null,
        seoOgimages: null,
        subtitle: null,
        thumbnailId: null,
        notListedOnPortal: false,
        translations: { ru: { isEnabled: true } },
        ticketGroups: null,
        attributes: {},
        profileType: null,
        profileId: null,
        sortOrder: null
      },
      eventSchedule: null,
      eventScheduleIdx: null
    }
  },
  computed: {
    redirerectToWebPortal () {
      if (this.data) {
        const { slug, primaryCategory } = this.data
        return window.location.href.includes('demo')
          ? `${process.env.VUE_APP_WEB_PORTAL_URL_DEMO}/events/${primaryCategory?.slug}/${slug}`
          : `${process.env.VUE_APP_WEB_PORTAL_URL}/events/${primaryCategory?.slug}/${slug}`
      }
      return '#'
    },
    eventId () {
      return this.data?.id || null
    },
    getZones () {
      return this.seating?.zones || null
    },
    isLoading () {
      return this.isMutationLoading || this.isFormLoading
    },
    validationRulesVars () {
      return {
        id: this.data?.id,
        ctx: this,
        isNew: this.isNew,
        eventSchedules: this.eventSchedules,
        address: this.fields.address
      }
    },
    getEventSchedulesArrayLength () {
      return this.eventSchedules?.length || null
    },
    getTimeZone () {
      return this.data?.city?.timezone || 'Asiza/Vladivostok'
    },
    isPrimaryCategoryMovie () {
      return !!(this.data?.primaryCategory?.slug === 'movies')
    }
  },
  watch: {
    data (data) {
      this.populate(data, () => {}, ['attributes'])
      this.prepareImages(data.images)
      if (Object.keys(data?.attributes).length) {
        this.populateDynamicFields(data.attributes)
      }
    },
    category (data) {
      if (!data) {
        return
      }
      this.primaryCategory = data.id
      if (!Object.keys(this.data).length) {
        this.prepareAttributesByCategory(data?.attributeKeys || [])
      }
    },
    loading (loading) {
      if (!loading) {
        window.scrollTo(0, 0)
      }
    }
  },
  methods: {
    prepareAttributesByCategory (attributeKeys = []) {
      attributeKeys.forEach(attr => {
        this.setDynamicAttrField(attr.name, {})
      })
    },
    updateAttributeValue ({ value, type, name }) {
      this.fields.attributes[name] = {
        value,
        type
      }
    },
    setDynamicAttrField (field, { type, value }) {
      // !Vue set!
      if (this.fields.attributes[field] === undefined) {
        this.$set(this.fields.attributes, field, {
          type,
          value
        })
      } else {
        this.fields.attributes[field] = {
          type,
          value
        }
      }
    },
    populateDynamicFields (attributes = {}) {
      const attrs = { ...attributes }
      for (const field in attrs) {
        this.setDynamicAttrField(
          attrs[field].type.name,
          formAttributeObject(attrs[field])
        )
      }
    },
    prepareImages (images) {
      this.fields.images = images.map(image => image.id)
    },
    prepareDateFormatPayload (value) {
      return moment(value).format(apiFormat)
    },
    preparedFormatTime (value) {
      if (value !== null) return moment(value || new Date()).format(defaultDateFormat)
      return value
    },
    prepareAttributesPayload (attributes = {}) {
      const attributesList = []
      if (Object.keys(attributes).length) {
        for (const key in attributes) {
          if (
            attributes[key] &&
            Object.values(attributes[key]).length &&
            attributes[key].value !== null &&
            attributes[key].type
          ) {
            attributesList.push({
              name: key,
              [fieldGenerator(attributes[key].type)]: attributes[key].value
            })
          }
        }
      }
      return { attributes: attributesList }
    },
    setLocation (location) {
      this.fields.address = location
    },
    updateLocation ({ value, fieldName }) {
      this.fields.address[fieldName] = value
    },

    // schedule
    addScheduleClick () {
      this.eventSchedule = null
      this.eventScheduleIdx = null
      this.$refs.FormDialogEvent.open(true)
    },

    async ChangeEventScheduleHandler (payload) {
      this.$refs.FormDialogEvent.close()
      this.eventSchedule = null
      this.$emit('new-event-schedule', payload)
    },
    editSchedule (eventSchedule, eventScheduleIndex) {
      this.eventSchedule = eventSchedule
      this.eventScheduleIdx = eventScheduleIndex
      this.$refs.FormDialogEvent.open()
    },
    eventScheduleDeleteHandler (item) {
      if (this.$refs?.FormDialogEvent?.close) {
        this.$refs.FormDialogEvent.close()
      }

      this.eventSchedule = null
      this.$emit('delete-event-schedule', item)
    },

    // seating
    async refetchSeating () {
      await this.$apollo.queries.seating.refetch()
    },

    updateTicketHandler (payload) {
      this.fields.ticketGroups = payload
    },

    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      if (!this.mixIsValidTranslations(this.fields.translations)) {
        this.$errorMsg('Не выбран ни один язык для контента!')
        return
      }
      const payload = {
        ...this.composeFormData(this.fields),
        ...this.prepareAttributesPayload(this.fields.attributes)
      }

      payload.address.lon = Number(payload.address.lon)
      payload.address.lat = Number(payload.address.lat)
      payload.altCategories = payload.altCategories.map(item => item.id)
      payload.price = Number(payload.price)
      delete payload.seoOgimages
      this.mixPrepareTranslations(payload)
      if (!payload.profileType) delete payload.profileType
      if (!payload.profileId) delete payload.profileId
      this.$emit('submit', payload)
    }
  },
  mounted () {
    if (!this.category) {
      this.$router.push({ name: 'page-events' })
    }
  },
  created () {
    this.prepareAttributesByCategory(this.category?.attributeKeys || [])
  }
}
</script>
<style>
.wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
